import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { AppCB } from './AppCB';
import Study from './pages/study/Study.vue';
import Country from './pages/country/Country.vue';
import Loading from '@/presentation/components/loading/Loading.vue';

export default defineComponent({
	props: {
		page: String,
	},
	components: {
		Study,
		Country,
		Loading,
	},
	setup: (props) => {
		const codeBehind = new AppCB(props.page);

		return setupComponent(codeBehind);
	},
});
